<!-- <button mat-raised-button color="primary" (click)="createRazorpayOrder()">Create Order</button>&nbsp;
<button mat-raised-button color="primary" (click)="checkout()">Checkout</button> -->

<div class="animated fadeIn" style="background-color: white; min-height: 100vh;">
  <div class="animated fadeIn flex-row-fluid">
    <div class="container content-space-t-1 content-space-t-lg-2">
      <div class="row justify-content-center align-items-lg-center">
        <div class="comment-box col-lg-12 mb-7 mb-sm-10 mb-lg-0" style="background-color: palevioletred !important; color : white">
          <div class="d-flex flex-row p-4 w-100 align-items-center">
            <h2 class="mb-0">Your payment is overdue. Please make payment asap to ensure uninterrupted access to Salesmax.</h2>
            <button mat-raised-button class="ml-auto" (click)="checkout()">Pay Now</button>
          </div>
        </div>
        <div class="col-lg-12 mb-7 mb-sm-10 mb-lg-0">
          @if (withinPaymentGrace) {
            <p style="cursor: pointer;" (click)="goToDashboard()">< Back To Dashboard</p>
          }

          <div class="d-flex flex-column w-100">
            <h4 class="text-center my-4">Your Billed Amount as on 11th Sep 2023 - Payable Immediately</h4>
            <div class="d-flex flex-row ml-auto mb-1">
              <button (click)="viewMembers()" class="btn btn-brand btn-sm btn-instagram mr-1" type="button">
                <i class="bi bi-people-fill"></i>
                <span>View Users</span>
              </button>
              <button [matMenuTriggerFor]="changePlan" class="btn btn-brand btn-sm btn-instagram mr-1" type="button">
                <i class="bi bi-shuffle"></i>
                <span>Change Plan</span>
              </button>
              <mat-menu #changePlan="matMenu">
                <div class="d-flex flex-column align-items-center">
                  <button mat-menu-item>Switch To Quarterly Plan</button>
                  <button mat-menu-item>Switch To Semi-Annual Plan</button>
                  <button mat-menu-item>Switch To Annual Plan</button>
                </div>
              </mat-menu>
            </div>
            <div class="card">
              <div class="table-responsive">
                <table class="table table-vcenter card-table">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Plan Type</th>
                      <th>Description</th>
                      <th>Quantity</th>
                      <th>For Period</th>
                      <th>Due Amount</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Plan Renewal</td>
                      <td>Monthly Plan</td>
                      <td class="text-secondary">
                        Renewal of your subscription plan
                      </td>
                      <td class="text-secondary">10 Users</td>
                      <td class="text-secondary">11th Sep 2023 to 10th Oct 2023</td>
                      <td class="text-secondary">
                        INR 15000
                      </td>
                      <td>
                        <a href="#">View</a>
                      </td>
                    </tr>
                    <tr>
                      <td>New User Addition</td>
                      <td>Monthly Plan</td>
                      <td class="text-secondary">
                        Newly added users who will continue the subscription
                      </td>
                      <td class="text-secondary">5 Users</td>
                      <td class="text-secondary">11th Sep 2023 to 10th Oct 2023</td>
                      <td class="text-secondary">
                        INR 5000
                      </td>
                      <td>
                        <a href="#">View</a>
                      </td>
                    </tr>
                    <tr>
                      <td>Pro-rata charges for extra usage</td>
                      <td>--</td>
                      <td class="text-secondary">
                        Pro-rata charges for added users
                      </td>
                      <td class="text-secondary">100 Hours</td>
                      <td class="text-secondary">11th Aug 2023 to 10th Sep 2024</td>
                      <td class="text-secondary">
                        INR 2500
                      </td>
                      <td>
                        <a href="#">View</a>
                      </td>
                    </tr>
                    <tr>
                      <td>Whatsapp Charges</td>
                      <td>--</td>
                      <td class="text-secondary">
                        Whatsapp Usage based charges in prior period
                      </td>
                      <td class="text-secondary">100 Conversations</td>
                      <td class="text-secondary">11th Aug 2023 to 10th Sep 2024</td>
                      <td class="text-secondary">
                        INR 3000
                      </td>
                      <td>
                        <a href="#">View</a>
                      </td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td></td>
                      <td class="text-secondary"> </td>
                      <td class="text-secondary"></td>
                      <td class="text-secondary"></td>
                      <td class="text-secondary">
                        INR 25500
                      </td>
                      <td>
                        <a href="#">Pay</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- End Col -->
      </div>
      <!-- End Row -->
    </div>
  </div>
</div>
